var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLiveChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50108 11.7136L4.50103 11.7168C4.48128 12.8788 4.74693 14.0282 5.27525 15.0689C5.48677 15.4856 5.60862 15.9805 5.56819 16.5069L5.29438 20.072L9.6031 19.0622C9.97679 18.9746 10.3455 18.975 10.6835 19.0333C11.1074 19.1065 11.5372 19.144 11.968 19.1456L11.9686 19.1456C16.103 19.1621 19.4654 15.8667 19.4997 11.8864L19.4997 11.8862C19.5082 10.9181 19.32 9.95741 18.9454 9.05975C18.5706 8.16202 18.0165 7.34443 17.3137 6.65547C16.6108 5.96645 15.7734 5.41996 14.8494 5.04935C13.9254 4.67873 12.9344 4.49183 11.9344 4.50027L11.9343 4.50027C7.85668 4.53452 4.55955 7.78849 4.50108 11.7136ZM20.9997 11.8994C21.01 10.7279 20.7822 9.5662 20.3296 8.48196C19.877 7.39772 19.2088 6.41268 18.3637 5.58431C17.5187 4.75594 16.5139 4.10082 15.4078 3.65717C14.3018 3.21353 13.1167 2.99024 11.9217 3.00033C7.05663 3.04119 3.07225 6.92435 3.00124 11.6913C2.97732 13.0992 3.29929 14.4903 3.93774 15.7479C4.0389 15.9472 4.08971 16.1692 4.0726 16.3921L3.76077 20.4522C3.70191 21.2186 4.40492 21.8212 5.15325 21.6458L9.94539 20.5226C10.1038 20.4855 10.2682 20.4838 10.4285 20.5115C10.9349 20.5988 11.4482 20.6437 11.9626 20.6456C16.8941 20.6653 20.958 16.7337 20.9997 11.8994Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChatIcon);
export default __webpack_public_path__ + "static/media/live-chat-icon.dfc89a95.svg";
export { ForwardRef as ReactComponent };